import { Injectable } from '@angular/core';
import { SpecialOfferPriceTypeEnum } from '../../constants/special-offer';

@Injectable({
  providedIn: 'root'
})
export class SpecialOfferService {

  constructor() { }

  getPrice(pricingType, priceExclTax) {
    switch (pricingType) {
      case SpecialOfferPriceTypeEnum.FREE:
        return 0;
      case SpecialOfferPriceTypeEnum.POA:
        return 0;
      case SpecialOfferPriceTypeEnum.FIXED:
        return priceExclTax;
      case SpecialOfferPriceTypeEnum.FROM:
        return Math.abs(Number(priceExclTax));
      default:
        return priceExclTax;
    }
  }

  getRawPrice(pricingType, priceExclTax) {
    switch (pricingType) {
      case SpecialOfferPriceTypeEnum.FREE:
        return -0.01;
      case SpecialOfferPriceTypeEnum.POA:
        return 0;
      case SpecialOfferPriceTypeEnum.FIXED:
        return priceExclTax;
      case SpecialOfferPriceTypeEnum.FROM:
        return -Math.abs(Number(priceExclTax));
      default:
        return priceExclTax;
    }
  }

  isFixedPrice(pricingType) {
    return pricingType === SpecialOfferPriceTypeEnum.FIXED || pricingType === SpecialOfferPriceTypeEnum.FROM;
  }

  getPriceLabel(specialOffer) {
    return specialOffer.pricingLabel || '';
  }
}
